export default "__VITE_ASSET__Bds7IeXV__"